import React from "react";
import { Link } from "react-router-dom";
import * as Lucide from "lucide-react";
import { ArrowUpRight } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const absUrl = (u) => (!u ? "" : u.startsWith("http") || u.startsWith("data:") ? u : `${BACKEND}${u}`);

/** Renders a Lucide icon by its kebab-case name, with a Sparkles fallback. */
function IconByName({ name, className }) {
  if (!name) return <Lucide.Sparkles className={className} />;
  const pascal = name
    .split("-")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");
  const Comp = Lucide[pascal] || Lucide.Sparkles;
  return <Comp className={className} />;
}

export default function CategoryCard({ category, index = 0 }) {
  const hasImage = Boolean(category.image);
  return (
    <Link
      to={`/providers?category_id=${category.id}`}
      data-testid={`category-card-${category.slug}`}
      className="group relative rounded-2xl border border-slate-200 bg-white overflow-hidden flex flex-col hover:border-[#165a71]/40 hover:shadow-[0_16px_40px_rgba(7,27,34,0.08)] hover:-translate-y-0.5 transition-[transform,box-shadow,border-color] duration-300 animate-fade-up"
      style={{ animationDelay: `${index * 40}ms` }}
    >
      {hasImage ? (
        <div className="relative h-32 w-full overflow-hidden">
          <img
            src={absUrl(category.image)}
            alt={category.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
            data-testid={`category-image-${category.slug}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#071b22]/50 to-transparent" aria-hidden />
          <div className="absolute bottom-2 left-2 h-9 w-9 rounded-xl bg-white/90 backdrop-blur text-[#165a71] flex items-center justify-center shadow-sm">
            <IconByName name={category.icon} className="h-4.5 w-4.5" />
          </div>
        </div>
      ) : null}

      <div className={hasImage ? "p-5 flex flex-col items-start gap-2" : "p-6 flex flex-col items-start gap-4"}>
        {!hasImage && (
          <div className="h-11 w-11 rounded-xl bg-[#165a71]/10 text-[#165a71] flex items-center justify-center group-hover:bg-[#165a71] group-hover:text-white transition-colors">
            <IconByName name={category.icon} className="h-5 w-5" />
          </div>
        )}
        <div>
          <div className="font-display text-base font-semibold text-[#071b22] leading-tight">
            {category.name}
          </div>
          <div className="text-xs text-[#252A34]/60 mt-1 uppercase tracking-wider">
            {category.kind === "digital" ? "Digital" : "Local"} · {category.slug}
          </div>
        </div>
      </div>
      <ArrowUpRight className="h-4 w-4 text-[#252A34]/40 group-hover:text-[#165a71] transition-colors absolute top-4 right-4 z-10" />
    </Link>
  );
}
